import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContactModel } from '../models/contact.model';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root'
})
export class GgsCompanyService {
  constructor(private http: HttpClient, private languageService: LanguageService) { }

  getCompanyDetails(): Observable<ContactModel> {
    return this.http.get<ContactModel>(`${this.languageService.getLanguage()}/ggs/contact`);
  }
}
